module.exports = __webpack_public_path__ + "static/img/button.18ea95f6.png";